import { API_BASE_URL, HEADERS_WITH_TOKEN, HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE } from "services/api/BaseUrl"

export const getMenus = async () => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))
  const bo = JSON.parse(localStorage.getItem('mqBO'))

  const res = await fetch(
    `${API_BASE_URL}/promotions/menus?cmp=${usr.company._id}&bo=${bo._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const getAll = (id) =>
  fetch(
    `${API_BASE_URL}/promotions/get-by-menu/${id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json())

export const save = async (data) => {
  const res = await fetch(
    `${API_BASE_URL}/promotions`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE(localStorage.getItem('mqadtk')),
      body: data
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/promotions/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE(localStorage.getItem('mqadtk')),
      body: params
    }
  )
  return await res.json()
}

export const remove = async (data) => {
  const { id, menuId } = data
  const res = await fetch(
    `${API_BASE_URL}/promotions/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ menuId: menuId })
    }
  )
  return await res.json()
}

export const updateOrder = async (data) => {
  const { menuId, params } = data
  const res = await fetch(
    `${API_BASE_URL}/promotions/update-order`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ menuId: menuId, value: params})
    }
  )
  return await res.json()
}

export const updateActive = async (data) => {
  const { id, menuId, params } = data
  const res = await fetch(
    `${API_BASE_URL}/promotions/update-active/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ menuId: menuId, active: params})
    }
  )
  return await res.json()
}

export const duplicate = async (data) => {
  const { id, menuId, params } = data
  const res = await fetch(
    `${API_BASE_URL}/promotions/duplicate/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ menuId: menuId, menusList: params})
    }
  )
  return await res.json()
}